"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIQUIDITY_TICKERS = void 0;
const fiat_balance_1 = require("./fiat-balance");
const ticker_1 = require("./ticker");
exports.LIQUIDITY_TICKERS = [ticker_1.Ticker.USDT, ...fiat_balance_1.FIAT_BALANCE_TICKERS];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlxdWlkaXR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RpY2tlcnMvbGlxdWlkaXR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLGlEQUFxRDtBQUNyRCxxQ0FBaUM7QUFFcEIsUUFBQSxpQkFBaUIsR0FBRyxDQUFDLGVBQU0sQ0FBQyxJQUFJLEVBQUUsR0FBRyxtQ0FBb0IsQ0FBQyxDQUFBIn0=